export enum ControlName {
	accountName = 'accountName',
    companyName = 'companyName',
    addressLine1 = 'addressLine1',
    addressLine2 = 'addressLine2',
	city= 'city',
    state = 'state',
    postalCode = 'postalCode',
    zipCode = 'zipCode'
};
